import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import TldrDropzone from "./TldrDropzone";
import { uploadFontFile } from "../../_actions/storiesActions";
import VariableFont from "../../_utils/variableFont";
import { fetchBrandKits, fetchBrandkitById, switchBrandkit } from "../../_actions/brandKitActions";
import FontHandler from "../canvas/handlers/FontHandler";
import { TldrBasicConfirmationModal } from "./statelessView";
import { FeatureCodes } from "../details/constants";
import connectedFeatureAvailabilityWrapper from "./withFeatureAvailability";
import { withTranslation } from "react-i18next";
import { onRejectFileDropzone } from "../../_utils/mimeType";

const opentype = require("opentype.js");

class FontsDropZone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConsentPopup: false,
      uploadingCount: 0,
      droppedFiles: [],
    };
  }

  render() {
    const { uploadingCount, showConsentPopup } = this.state;
    const { brandKitId, buttonWidth, className, t } = this.props;
    return (
      <>
        <TldrDropzone
          isUploading={uploadingCount > 0}
          btnTitle={t("dropzone_button_title")}
          brandKitId={brandKitId}
          buttonWidth={100}
          description={t("dropzone_button_desc")}
          onDrop={(droppedFiles) => {
            this.props.checkFeatureAvailability(FeatureCodes.CUSTOM_FONTS, () =>
              this.onFontsDrop(droppedFiles)
            );
          }}
          className={className}
          dropzoneProps={{
            onDropRejected: (rf) => onRejectFileDropzone(rf, t, true),
          }}
        />
        <TldrBasicConfirmationModal
          title={t("font_conf_modal_title")}
          message={t("font_conf_modal_detail")}
          inProgress={uploadingCount > 0}
          show={showConsentPopup}
          onHide={(e) => {
            this.setState({
              ...this.state,
              showConsentPopup: false,
              droppedFiles: [],
            });
          }}
          onYes={() => {
            this.processFontFiles(this.state.droppedFiles);
          }}
        />
      </>
    );
  }

  onFontsDrop = (droppedFiles) => {
    this.setState({
      ...this.state,
      showConsentPopup: true,
      droppedFiles,
    });
  };

  processFontFiles = (fontFiles) => {
    if (fontFiles.length > 0) {
      this.setState(
        {
          ...this.state,
          uploadingCount: fontFiles.length,
        }
      );
    }

    const { brandKitId, auth } = this.props;
    const selectedOrgId = auth.payload.selectedOrg;

    fontFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onabort = () => console.warn("file reading was aborted");
      reader.onerror = () => console.error("file reading has failed");
      reader.onload = (e2) => {
        try {
          let fontBuffer = e2.target.result;
          let vf = new VariableFont(opentype.parse(fontBuffer));
          this.props
            .uploadFontFile(
              selectedOrgId,
              file,
              vf.getMetaInformation(),
              brandKitId
            )
            .then((fontInfo) => {
              if (brandKitId) {
                this.props.fetchBrandKits();
                this.props.fetchBrandkitById(brandKitId)
                  .then((responseData) => {
                    this.props.switchBrandkit(responseData);
                  });
              }

              let fontHandler = new FontHandler(null);
              fontHandler.addFont(fontInfo);

              this.setState({
                ...this.state,
                uploadingCount: this.state.uploadingCount - 1,
                showConsentPopup: this.state.uploadingCount - 1 !== 0,
              });
            });
        } catch (err) {
          console.error(err);
          this.setState({
            ...this.state,
            uploadingCount: 0,
            droppedFiles: [],
          });
        }
      };
      reader.readAsArrayBuffer(file);
    });
  };
}

FontsDropZone.propTypes = {
  auth: PropTypes.object.isRequired,
};

FontsDropZone.defaultProps = {
  brandKitId: null,
  buttonWidth: 100,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription: state.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  uploadFontFile: (orgId, file, metaInfo, brandKitId) =>
    dispatch(uploadFontFile(orgId, file, metaInfo, brandKitId)),
  fetchBrandKits: () => dispatch(fetchBrandKits()),
  fetchBrandkitById: (id) => dispatch(fetchBrandkitById(id)),
  switchBrandkit: (payload) => dispatch(switchBrandkit(payload)),
});

export default withTranslation(["fontlist", "billing"])(
  connectedFeatureAvailabilityWrapper(
    connect(mapStateToProps, mapDispatchToProps)(FontsDropZone)
  )
);
